<template>
  <div>
    <!-- <div ref="mapDiv" style="width:800px;height:800px;" /> -->
    <bt-chart ref="testMap" :options="optionsData" style="width:100%;height:100%" :autoresize="true" />
  </div>
</template>

<script>
import jiangdu from "@/assets/json/jiangdu.json"
import drawCharts from '@/mixins/drawCharts.js'
import loading from '@/mixins/loading.js'
export default {
  mixins: [drawCharts, loading],
  props: {
    mapObj: {
      type: Object,
      default: () => {}
    },
    list1: {
      type: Array,
      default: () => []
    },
    list2: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      geoCoordMap: {},
      optionsData: {}
    }
  },
  watch: {
    mapObj: {
      handler(newVal) {
        this.$nextTick(()=>{
        this.showLoading(this.$refs.testMap)
          if (newVal.data && newVal.data.length > 0) {
            this.hideLoading(this.$refs.testMap)
            this.setDirOptions()
          }
        })       
      },
      immediate:true
    }
  },
  mounted() {
    
    // this.$nextTick(() => {
    //   this.setDirOptions()
    // })
  },
  methods: {
    async setDirOptions() {
      await this.registerMap()
      await this.setOptions()
    },
    registerMap() {
      return new Promise((resolve) => {
        this.$refs.testMap.$options.registerMap(this.mapObj.platform,jiangdu)
        jiangdu.features.map(item => {
          const name = item.properties.name
          let target
          if (item.geometry.coordinates[0][0].length === 2) {
            target = item.geometry.coordinates[0]
          } else {
            target = item.geometry.coordinates[0][0]
          }
          const centerXArr = target.map(item => item.find((sonItem, sonIndex) => sonIndex === 0))
          const centerX = centerXArr.reduce((a, b) => Number(a) + Number(b)) / centerXArr.length
          const centerYArr = target.map(item => item.find((sonItem, sonIndex) => sonIndex === 1))
          const centerY = centerYArr.reduce((a, b) => Number(a) + Number(b)) / centerYArr.length
          const cp = [centerX, centerY]
          this.geoCoordMap[`${name}`] = cp
          resolve();
      })
    })
    },
    convertData() {
      const res = []; const data = this.mapObj.data
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          const geoCoord = this.geoCoordMap[data[i].name]
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            })
          }
        }
      }
      return res
    },
    setOptions() {
      this.optionsData = {
        backgroundColor: 'transparent',
        zoom: 1,
        aspectScale: 1, // 长宽比
        layoutSize: '95%',
        layoutCenter: ['50%', '50%'],
        left: '5%',
        right: '5%',
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            if (typeof (params.value)[2] === 'undefined') {
              return params.name + ' : ' + params.value
            } else {
               return params.name + ' : ' + params.value[2]
            }
          }
        },
        visualMap: {
          show: false,
          min: 0,
          max: 500,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'], // 文本，默认为数值文本
          calculable: true,
          seriesIndex: [1],
          inRange: {

          }
        },
        geo: {
          map: this.mapObj.platform,
          show: true,
          roam: false,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#798DD6',
              borderColor: '#0a53e9', // 线
              shadowColor: '#092f8f', // 外发光
              shadowBlur: 20
            },
            emphasis: {
              areaColor: '#3957c7' // 悬浮区背景
            }
          }
        },
        series: [
          {
            type: 'map',
            z: 1,
            mapType: this.mapObj.platform,
            geoIndex: 0,
            aspectScale: 0.75, // 长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: true,
                position: 'center',
                color: '#fff'
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              }
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: '#031525',
                borderColor: '#FFFFFF'
              },
              emphasis: {
                areaColor: '#2B91B7'
              }
            },
            animation: false,
            data: this.mapObj.data
          },
          {
            z: 1,
            symbolSize: 5,
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: true
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#fff'
              }
            },
            name: 'light',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: this.convertData()

          },
          {
            z: 1,
            name: 'Top 5',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: 'pin',
            symbolSize: [50, 50],
            label: {
              normal: {
                show: true,
                color: '#fff',
                fontSize: 12,
                formatter(value) {
                  return value.data.value[2]
                }
              }
            },
            itemStyle: {
              normal: {
                color: '#c05d5d' // 标志颜色
              }
            },
            data: this.convertData(),
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            hoverAnimation: true,
            zlevel: 1
          }
        ]
      }
      // console.log('optionsData', this.optionsData)
    }
  }
}
</script>

<style>

</style>
